import isEqual from 'lodash-es/isEqual';
import mutations from './filters.mutationlist';

const updateDynamicFilters = (commit, dynamic, attributeTypes) => {
  // Update dynamic fields
  if (dynamic) {
    const dynamicValue = Object.keys(dynamic)
      .filter(key => attributeTypes.find(
        atType => dynamic[key] && Number(atType.id) === Number(dynamic[key].type.id)),
      ).reduce((ac, key) => ({
        ...ac,
        [key]: dynamic[key],
      }), {});

    if (!isEqual(dynamicValue, dynamic)) {
      commit(mutations.FILTER_SET, {
        key: 'dynamic',
        value: dynamicValue,
      });
    }
  }
};

export default {
  setCategory({ commit, state, getters }, value) {
    commit(mutations.SELECT_CATEGORY, value);

    // Update dynamic fields
    setTimeout(() => { updateDynamicFilters(commit, state.dynamic, getters.attributeTypes); });
  },
  setSubcategory({ commit, state, getters }, value) {
    commit(mutations.SELECT_SUBCATEGORY, value);

    // Update dynamic fields
    setTimeout(() => { updateDynamicFilters(commit, state.dynamic, getters.attributeTypes); });
  },
};



// WEBPACK FOOTER //
// ./src/store/filters/filters.actions.js